// Payment status keys
const PAYMENT_STATUS_KEY = 'session_payment_status';

export const paymentUtils = {
  // Set payment completed status
  setPaymentCompleted: () => {
    localStorage.setItem(PAYMENT_STATUS_KEY, 'true');
  },

  // Check if payment is completed
  isPaymentCompleted: () => {
    return localStorage.getItem(PAYMENT_STATUS_KEY) === 'true';
  },

  // Clear payment status
  clearPaymentStatus: () => {
    localStorage.removeItem(PAYMENT_STATUS_KEY);
  }
}; 